export const FLAG_SHOP_ONLINE_VIDEOS = "shop-online-videos"